import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';

export type GorgiasResponse = {
  name: string;
};

const GorgiasRedirect = () => {
  const [, setRedirect] = useCrossWindowState<GorgiasResponse | null>(
    'gorgias-redirect',
    null,
  );

  const { navigate } = useWorkspaceRouter();
  const [searchParams, _] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const data = sessionStorage.getItem(state);
      if (!data) return;
      const { workspaceAlias, subdomain } = JSON.parse(data);

      const asyncUpdateHandler = async () => {
        const data = await services.gorgias.createGorgiasInfo(
          code,
          workspaceAlias,
          `${window.location.origin}/gorgias`,
          subdomain,
        );
        if (data) {
          setRedirect(data);
          window.close();
        } else {
          navigate('/500', {
            replace: true,
          });
        }
      };
      asyncUpdateHandler();
    }
  }, [navigate, setRedirect, searchParams]);

  return <LoadingLayout>Connecting Gorgias...</LoadingLayout>;
};

export default GorgiasRedirect;
